import { useMemo } from 'react'

import { useFilters } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

interface AgenciesOverviewProps {
  brandId: number,
}

const AgenciesOverview = (props: AgenciesOverviewProps) => {
  const { brandId } = props

  const { callbacks: filterCallbacks, defaultFilters, pageFilters } = useFilters()

  const pageContext = useMemo(
    () => ({
      callbacks: {
        ...filterCallbacks,
        updateBrand: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      },
      defaultFilters,
    }),
    [],
  )

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent brandId={brandId} pageFilters={pageFilters} />
    </PageContext.Provider>
  )
}

export default AgenciesOverview
